import React, { Component } from "react";

class DateUpSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <path
          className="svg"
          d="M5,9.4h2.6v2.6H5V9.4z M8.8,9.4h2.6v2.6H8.8V9.4z M5,5.6h2.6v2.6H5V5.6z M8.8,5.6h2.6v2.6H8.8V5.6z M12.6,9.4
	h2.6v2.6h-2.6V9.4z M16.4,9.4H19v2.6h-2.6V9.4z M12.6,5.6h2.6v2.6h-2.6V5.6z M16.4,5.6H19v2.6h-2.6V5.6z M5,16.9h2.6v2.6H5V16.9z
	 M8.8,16.9h2.6v2.6H8.8V16.9z M5,13.2h2.6v2.6H5V13.2z M8.8,13.2h2.6v2.6H8.8V13.2z M12.6,16.9h2.6v2.6h-2.6V16.9z M16.4,16.9H19
	v2.6h-2.6V16.9z M12.6,13.2h2.6v2.6h-2.6V13.2z M16.4,13.2H19v2.6h-2.6V13.2z M20.6,1.2h-2.5V0.5c0-0.3-0.2-0.5-0.5-0.5h-0.1
	c-0.3,0-0.5,0.2-0.5,0.5v0.7h-4.6V0.5C12.5,0.2,12.3,0,12,0H12c-0.3,0-0.5,0.2-0.5,0.5v0.7H6.9V0.5C6.9,0.2,6.7,0,6.4,0H6.3
	C6.1,0,5.8,0.2,5.8,0.5v0.7H3.4C1.8,1.2,0.6,2.4,0.6,4v17.3c0,1.5,1.3,2.8,2.8,2.8h17.3c1.5,0,2.8-1.3,2.8-2.8V4
	C23.4,2.4,22.2,1.2,20.6,1.2z M21.5,21.2c0,0.5-0.4,0.8-0.8,0.8H3.4c-0.5,0-0.8-0.4-0.8-0.8V4c0-0.5,0.4-0.8,0.8-0.8h2.5v0.8
	c0,0.3,0.2,0.5,0.5,0.5h0.1c0.3,0,0.5-0.2,0.5-0.5V3.1h4.6v0.8c0,0.3,0.2,0.5,0.5,0.5H12c0.3,0,0.5-0.2,0.5-0.5V3.1h4.6v0.8
	c0,0.3,0.2,0.5,0.5,0.5h0.1c0.3,0,0.5-0.2,0.5-0.5V3.1h2.5c0.5,0,0.8,0.4,0.8,0.8L21.5,21.2L21.5,21.2z M3.8,11
	c-0.1,0-0.2-0.1-0.2-0.2V7.2c0-0.1,0.1-0.2,0.2-0.2C3.9,6.9,4,7,4,7.2v3.6C4,10.9,3.9,11,3.8,11z M3.8,6.4c-0.1,0-0.2-0.1-0.2-0.2
	V5.9c0-0.1,0.1-0.2,0.2-0.2C3.9,5.7,4,5.8,4,5.9v0.2C4,6.2,3.9,6.4,3.8,6.4z"
        />
      </svg>
    );
  }
}

export default DateUpSVG;



// WEBPACK FOOTER //
// ./src/svg/DateUpSVG.jsx